<template>
  <form role="form" @submit.stop.prevent="">
    <vs-card>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-input
            class="w-full"
            label="Solicitante"
            name="solicitante"
            v-model="form.solicitante"
            v-validate="{ required: true, min: 8 }"
            :state="validateState('Solicitante')"
            :danger="validateClass('solicitante')"
            val-icon-danger="clear"
            danger-text="Informe o nome completo de quem solicita este atendimento"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label for="" class="vs-select--label">Classificação do Anexo</label>
          <v-select
            :options="classificacaoAnexo"
            name="Classificação do Anexo"
            id="Classificacao do Anexo"
            v-model="form.idClassificacaoAnexo"
            label="descricao"
            class="select-large w-full"
            :reduce="(item) => item.idClassificacaoAnexo"
            :disabled="!existPhoto"
          ></v-select>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label for="" class="vs-select--label">Setor</label>
          <v-select
            :options="setores"
            name="Setor"
            id="Setor"
            v-model="form.idSetor"
            label="nomeSetor"
            class="select-large w-full"
            :reduce="(item) => item.idSetor"
            v-validate="{ required: true }"
            :state="validateState('Setor')"
            :danger="validateClass('Setor')"
          ></v-select>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label for="" class="vs-select--label">Tipo de Atendimento</label>
          <v-select
            :options="tiposRelacionamento"
            name="Tipo de Atendimento"
            id="Tipo de Atendimento"
            class="select-large w-full"
            v-model="form.idTipoAtendimento"
            label="tipoRelacionamento"
            :reduce="(item) => item.idTipoRelacionamento"
            v-validate="{ required: true }"
            :state="validateState('Tipo de Atendimento')"
            :danger="validateClass('Tipo de Atendimento')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label for="" class="vs-select--label">Status do Atendimento</label>
          <v-select
            :options="statusRelacionamento"
            name="Status do Atendimento"
            id="Status do Atendimento"
            v-model="form.idStatus"
            label="statusRelacionamento"
            class="select-large w-full"
            :reduce="(item) => item.idStatusRelacionamento"
            v-validate="{ required: true }"
            :state="validateState('Status do Atendimento')"
            :danger="validateClass('Status do Atendimento')"
          ></v-select>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label for="" class="vs-select--label">Placa / Chassi</label>
          <v-select
            :options="dadosVeiculo"
            name="Placa / Chassi"
            id="Placa / Chassi"
            v-model="form.idVeiculos"
            label="placaChassi"
            class="select-large w-full"
            v-validate="{ required: possuiVeiculos }"
            :reduce="(item) => item.idVeiculo"
            :state="validateState('Placa / Chassi')"
            :danger="validateClass('Placa / Chassi')"
            multiple
          ></v-select>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <vs-input
            class="w-full"
            label="Assunto"
            name="Assunto"
            v-model="form.assunto"
            v-validate="{ required: true, min: 8 }"
            :state="validateState('assunto')"
            :danger="validateClass('assunto')"
            val-icon-danger="clear"
            danger-text="Preencha o assunto deste atendimento"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <vs-textarea
            label="Descrição"
            name="Descrição"
            v-model="form.descricaoSolicitacao"
            v-validate="{ required: true, min: 20 }"
            :state="validateState('Descrição')"
            :danger="validateClass('Descrição')"
            danger-text="Preencha a descrição"
          />
        </div>
      </div>

      <div class="mb-5">
        <div v-if="listArquivos.length === 0" class="p-5">
          <h6>Não há fotos ou documentos a serem exibidos.</h6>
        </div>
        <div v-else class="vx-row">
          <div
            class="vx-col md:w-1/2 lg:w-1/4 xl:w-1/4 w-full mt-5"
            v-for="arquivo in listArquivos"
            :key="arquivo.idEventoFoto"
          >
            <vs-card :class="{ remove: arquivo.deletar }">
              <div class="flex justify-between">
                <div class="p-2 break-all">
                  <a :href="getObjectURL(arquivo)" target="_blank">
                    {{ arquivo.legenda ? arquivo.legenda : arquivo.name }}
                  </a>
                  <p>
                    {{ arquivo.type }}
                  </p>
                </div>

                <div class="flex">
                  <vs-button
                    v-if="arquivo.deletar"
                    v-tooltip="'Deletar arquivo'"
                    type="gradient"
                    color="success"
                    icon="undo"
                    size="small"
                    @click="undoArquivoToDelete(arquivo)"
                  ></vs-button>

                  <vs-button
                    v-else
                    v-tooltip="'Deletar arquivo'"
                    type="gradient"
                    color="danger"
                    icon="close"
                    size="small"
                    @click="selectArquivoToDelete(arquivo)"
                  ></vs-button>
                </div>
              </div>

              <div>
                <a
                  v-if="isPdf(arquivo.nome)"
                  class="flex justify-center"
                  :href="getObjectURL(arquivo)"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    class="w-1/2"
                    src="../../../src/assets/images/elements/PDF_file_icon2.png"
                  />
                </a>

                <img
                  v-else
                  @click="formUploadFotos(arquivo)"
                  class="w-full cursor-pointer"
                  :src="arquivo.url"
                /></div
            ></vs-card>
          </div>
        </div>

        <div v-if="listArquivos.length >= 40">
          <vs-alert title="Atenção" active="true" color="danger">
            Você chegou ao limite máximo de 40 fotos. Favor remover fotos atuais
            para poder acrescentar novas fotos.
          </vs-alert>
        </div>

        <div class="pt-5 pl-5">
          <span class="colorBlue"
            >Limite de fotos: {{ listArquivos.length }} / 40</span
          >
        </div>
        <div
          class="flex justify-end gap-3 items-center mt-2 lg:flex-row flex-col"
        >
          <div class="flex gap-3 lg:flex-row flex-col">
            <vs-button
              color="danger"
              :disabled="!listArquivosToDelete.length"
              @click="deleteRegistroArquivos()"
            >
              <div class="flex items-center gap-2">
                <feather-icon icon="Trash2Icon" />
                <span>
                  Deletar: {{ listArquivosToDelete.length }} arquivos
                  selecionados
                </span>
              </div></vs-button
            >
          </div>
          <div>
            <vs-button
              @click="openModalUpload"
              :active.sync="modalUploadAtivo"
              :disabled="listArquivos.length > 40"
              class="w-full"
            >
              <div class="flex items-center gap-2">
                <feather-icon icon="UploadIcon" />Escolher arquivos
              </div></vs-button
            >
          </div>
        </div>
        <vs-popup
          class="main-popup-anexo"
          :title="'Upload de Fotos e Documentos'"
          :active.sync="modalUploadAtivo"
        >
          <div>
            <formUploadFotos
              :key="dadosRelacionamento.index"
              :dadosRelacionamento.sync="dadosRelacionamento"
              ref="formRelacionamentoRef"
              @dataChanged="handleExistPhoto"
            >
            </formUploadFotos>
          </div>
        </vs-popup>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>

      <div class="vx-row">
        <div class="vx-col w-full text-center">
          <vs-button color="success" type="gradient" @click="onSubmit"
            >Salvar</vs-button
          >
        </div>
      </div>
    </vs-card>
  </form>
</template>
<script>
import service from './../../services';
import locale from './../../locale';
import vSelect from 'vue-select';
import jwt from 'jsonwebtoken';
import formUploadFotos from './../forms/FormUploadFotos.vue';
import functions from '../../utils/functions';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  props: [
    'idAssociado',
    'setores',
    'tiposRelacionamento',
    'statusRelacionamento',
    'dadosVeiculo',
    'idEmpresa',
    'nomeAssociado',
    'buscarRelacionamentos',
    'possuiVeiculos',
    'classificacaoAnexo',
  ],
  components: {
    'v-select': vSelect,
    formUploadFotos,
  },
  data() {
    return {
      aguardeCadastro: false,
      form: {
        idStatus: null,
        idSetor: null,
        idTipoAtendimento: null,
        solicitante: this.nomeAssociado,
        idVeiculo: null,
        idVeiculos: [],
        assunto: null,
        descricaoSolicitacao: null,
        idClassificacaoAnexo: null,
      },
      listArquivosToDelete: [],
      listArquivos: [],
      modalUploadAtivo: false,
      ip: null,
      dadosRelacionamento: {
        idRelacionamento: null,
        idAssociado: null,
        idVeiculos: null,
        idVeiculo: null,
        idUsuario: null,
        ip: null,
        url: null,
      },
      existPhoto: false,
    };
  },
  methods: {
    getObjectURL(file) {
      return URL.createObjectURL(file);
    },
    openModalUpload() {
      this.modalUploadAtivo = true;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    resetForm() {
      this.form = {
        idStatus: null,
        idSetor: null,
        idTipoAtendimento: null,
        solicitante: null,
        idVeiculo: null,
        idVeiculos: [],
        assunto: null,
        descricaoSolicitacao: null,
        idClassificacaoAnexo: null,
        listArquivos: [],
      };
      this.dadosRelacionamento = {
        idRelacionamento: null,
        idAssociado: null,
        idVeiculos: null,
        idVeiculo: null,
        idUsuario: null,
        ip: null,
        url: null,
      };

      this.autoFillFields();
    },
    async onSubmit() {
      const newRelacionamento = {
        idEmpresa: this.idEmpresa,
        ...this.form,
        idVeiculos: this.form.idVeiculos.join(','),
      };

      const { idAssociado } = this.$route.params;

      try {
        this.$vs.loading();
        const relacionamentoDataReturn = await service.post(
          'Relacionamento',
          `inserirAtendimento/${idAssociado}`,
          newRelacionamento,
        );
        if (relacionamentoDataReturn.data && this.listArquivos.length > 0) {
          const { data } = relacionamentoDataReturn;
          this.dadosRelacionamento = {
            idRelacionamento: data.idRelacionamento,
            idAssociado: data.idAssociado,
            idVeiculos: data.idVeiculos,
            idVeiculo: data.idVeiculo,
            idUsuario: data.createdBy,
            ip: this.ip,
            url: null,
          };
          await this.saveListImage();
        }

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Atendimento registrado com sucesso',
          color: 'success',
        });

        this.$emit('concluido');
        this.resetForm();
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error.message || 'Erro ao inserir relacionamento no sistema',
          color: 'danger',
        });
        return Promise.reject(error);
      }
    },
    async saveListImage() {
      try {
        const formDataSend = new FormData();

        this.listArquivos.forEach((file) => {
          formDataSend.append('files', file);
        });

        const { uploadedFiles } = await service.uploadAll(
          'upload-multi',
          'Eventos/' + this.dadosRelacionamento.idRelacionamento,
          formDataSend,
        );

        await this.inserirAnexoRelacionamento(uploadedFiles);
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error.message || 'Erro ao realizar upload das imagens',
          color: 'danger',
        });
        return Promise.reject(error);
      }
    },
    autoFillFields() {
      const userToken = localStorage.getItem('user-token');
      const { id_setor } = jwt.decode(userToken);

      // get setor info
      if (id_setor != 13) {
        this.form.idSetor = id_setor;
      }

      // get tipo atendimento info
      const setorData = this.setores.find((setor) => setor.idSetor == id_setor);
      const tipoRelacionamento = this.tiposRelacionamento.find(
        (tipo) =>
          tipo.tipoRelacionamento.replace(' ', '').toUpperCase() ==
          setorData.nomeSetor.replace(' ', '').toUpperCase(),
      );
      if (tipoRelacionamento != undefined) {
        this.form.idTipoAtendimento = tipoRelacionamento.idTipoRelacionamento;
      }

      // auto fill chassi / placa
      if (this.dadosVeiculo.length == 2) {
        this.form.idVeiculos.push(this.dadosVeiculo[1].idVeiculo);
      }
    },
    handleExistPhoto(photo) {
      this.existPhoto = true;
      this.listArquivos = this.listArquivos.concat(photo);
      this.modalUploadAtivo = false;
    },
    isPdf(urlArquivo) {
      if (!urlArquivo) return false;

      const ext = urlArquivo.split('.').pop();

      return ext === 'pdf';
    },
    selectArquivoToDelete(arquivoSelecionado) {
      arquivoSelecionado.deletar = true;
      this.listArquivosToDelete.push(arquivoSelecionado);
    },
    undoArquivoToDelete(arquivoSelecionado) {
      delete arquivoSelecionado.deletar;

      const index = this.listArquivosToDelete.findIndex(
        (item) => item.idArquivo === arquivoSelecionado.idArquivo,
      );

      if (index !== -1) {
        this.listArquivosToDelete.splice(index, 1);
      }
    },
    deleteRegistroArquivos() {
      this.listArquivos = this.listArquivos.filter(
        (arquivo) => !this.listArquivosToDelete.includes(arquivo),
      );
      this.listArquivosToDelete = [];
    },
    async inserirAnexoRelacionamento(uploadedFiles) {
      try {
        const listFiles = uploadedFiles.map((file) => ({
          idRelacionamento: this.dadosRelacionamento.idRelacionamento,
          idAssociado: this.dadosRelacionamento.idAssociado,
          idVeiculos: this.dadosRelacionamento.idVeiculos,
          uploadedBy: this.dadosRelacionamento.idUsuario,
          url: file,
        }));

        const result = await service.post(
          'Relacionamento',
          'inserir-anexos-relacionamento',
          listFiles,
        );

        return result;
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error.message || 'Erro ao inserir os anexos no sistema',
          color: 'danger',
        });
        return Promise.reject(error);
      }
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    this.autoFillFields();
    this.ip = functions.getIP();
  },
  beforeDestroy() {
    this.listArquivos.forEach((file) => {
      if (file instanceof File || file instanceof Blob) {
        URL.revokeObjectURL(file);
      }
    });
  },
};
</script>
<style></style>
